import { render, staticRenderFns } from "./SectionSliderImages.vue?vue&type=template&id=f37e965c&scoped=true&"
import script from "./SectionSliderImages.vue?vue&type=script&lang=js&"
export * from "./SectionSliderImages.vue?vue&type=script&lang=js&"
import style0 from "./SectionSliderImages.vue?vue&type=style&index=0&id=f37e965c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37e965c",
  null
  
)

export default component.exports